import React from 'react';
import {Container} from '@material-ui/core';
import {FirebaseContext} from '../../Firebase';
import {Button, TextField} from '@material-ui/core';
import ReactGoogleSlides from 'react-google-slides';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

const Session12 = () => {
  const firebase = React.useContext(FirebaseContext);
  const group = firebase.userData.group;
  const [scr, setScr] = React.useState(0);
  const [CR, setCR] = React.useState(false);
  const [response, setResponse] = React.useState('');
  const [respQ, setRespQ] = React.useState('');
  return (
    <div>
      <Container
        style={{
          backgroundColor: 'lightblue',
          padding: '10px',
          minHeight: '270px',
        }}
      >
        {/* SCREENS INTRO ALL GROUP*/}
        {scr === 0 && (
          <div>
            <h3>Bonjour et bienvenue !</h3>
            <p>
              Au programme aujourd’hui, nous continuons notre chemin à la
              découverte des gestes du quotidien pour ceux qui nous entourent.
            </p>
            <p>
              Clique sur le bouton continuer une fois que tu as bien compris
              pour continuer.
            </p>
          </div>
        )}
        {scr === 1 && (
          <div style={{textAlign: 'center', width: '100%'}}>
            <ReactGoogleSlides
              width={'100%'}
              height={480}
              slidesLink="https://docs.google.com/presentation/d/1iCDquY-ulO8fm94YKSYeMbeZLaE89SeanjIY-JbVDfY"
              position={0}
              showControls
            />
            <br />
            <FormControl component="fieldset">
              <FormLabel component="legend">
                La vidéo dans cette session propose de mettre un pull plutôt que
                d’augmenter le chauffage chez soi :
              </FormLabel>
              <RadioGroup
                aria-label="team"
                defaultValue=""
                name="radio-buttons-group-team"
                onChange={(e) => {
                  setCR(true);
                  setResponse(e.target.value);
                }}
              >
                <FormControlLabel
                  value="vrai"
                  control={<Radio />}
                  label="Vrai"
                />
                <FormControlLabel
                  value="faux"
                  control={<Radio />}
                  label="Faux"
                />
              </RadioGroup>
            </FormControl>
          </div>
        )}
        {/* SCREENS CONTROL*/}
        {group.toString() === 'control' && scr === 2 && (
          <div>
            <p>
              Revenons à ton spectacle. Pour cette dernière étape, tu vas devoir
              décider comment répartir les rôles et le matériel.
            </p>
          </div>
        )}
        {group.toString() === 'control' && scr === 3 && (
          <div>
            <p>
              13 enfants de la classe de CP vont participer au spectacle. Tu
              peux leur attribuer des rôles dans le spectacle, ou alors les
              charger de peindre les décors, préparer la salle, et toute autre
              action que tu penses nécessaire.
            </p>
            <p>
              A toi de distribuer les tâches et les rôles pour ta dernière
              mission de metteur en scène ! Tu peux écrire ci-dessous pour
              chaque enfant ce que tu as décidé (par exemple : "Elève 1 :
              préparer la salle. Elève 2 : peindre les décors", etc)
            </p>

            <TextField
              multiline
              fullWidth
              rows="4"
              id="regles"
              label="Tes choix"
              variant="outlined"
              value={respQ}
              onChange={(e) => {
                setRespQ(e.target.value);
              }}
            />
            <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
          </div>
        )}
        {group.toString() === 'control' && scr === 4 && (
          <div>
            <p>
              Nous avons terminé pour aujourd’hui. Bravo pour l’organisation de
              ce spectacle !
            </p>
            <p>
              N’oublie pas de te connecter dans quelques jours pour la prochaine
              séance.{' '}
            </p>
            <p>Merci pour ta participation !</p>
            <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
          </div>
        )}
        {/* SCREENS TEST*/}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 2 && (
            <div>
              <p>
                Il est temps de continuer à organiser ton action bénévole. Pour
                cette dernière étape, tu vas devoir décider comment répartir les
                rôles et le matériel entre les membres du groupe.
              </p>
            </div>
          )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 3 && (
            <div>
              <p>
                13 bénévoles vont participer. Tu peux leur attribuer des rôles
                dans cette action (par exemple aider à fabriquer des choses,
                distribuer ce qui a été fabriqué, etc.).
              </p>
              <p>
              Tu peux écrire ci-dessous pour
              chaque bénévole ce que tu as décidé (par exemple : "Bénévole 1 :
              fabriquer des choses. Bénévole 2 : distribuer ce qui a été fabriqué", etc)
              </p>
              <TextField
                multiline
                fullWidth
                rows="4"
                label="Tes choix"
                variant="outlined"
                value={respQ}
                onChange={(e) => {
                  setRespQ(e.target.value);
                }}
              />
              <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
            </div>
          )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 4 && (
            <div>
              <p>
                Nous avons terminé pour aujourd’hui. N’oublie pas de te
                connecter dans quelques jours pour la prochaine séance.
              </p>
              <p>Merci pour ta participation !</p>
              <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
            </div>
          )}
      </Container>
      {/* BUTTON*/}
      <Button
        style={{display: 'block', margin: 'auto'}}
        disabled={scr === 1 && !CR}
        variant="contained"
        color="primary"
        onClick={() => {
          if (scr === 3) {
            // save TEST DATA
            let now = new Date();
            firebase
              .databehav(firebase.userData.pseudo)
              .collection('session12')
              .add({
                date: now,
                response: response,
                respChoix: respQ,
              })
              .catch((error) => {
                console.log(error);
              });
          }
          if (scr === 4) {
            firebase.signoutUser();
          } else {
            setScr(scr + 1);
          }
        }}
      >
        Continuer
      </Button>
    </div>
  );
};
export default Session12;
